const columnCheck = {
    //device
    deviceModel: '设备型号',
    deviceExtra: '主机编号',
    devicePhoneNo: '电话号码',
    IMSI: 'IMSI',
    ICCID: 'ICCID',
    manufacturer: '厂商',
    serialNumber: '序列号',
    softwareVersion: '软件版本',
    productionDate: '生产日期',
    deviceOrg: '所属机构',
    deviceStatus: '状态',
    deviceRemark: '备注 / 封签号',
    packageDate: '套餐到期时间',
    operate: '操作',
    //alarm
    alarmType: '告警类型',
    alarmLevel: '告警级别',
    name: '人员',
    alarmTime: '告警时间',
    group: '所属分组',
    alarmStatus: '状态',
    notice: '通知',
    description: '告警描述',
    //supervise
    power: '电量',
    lastOnlineTime:'最后在线时间',
    joinGroupTime: '入组时间',
    absent: '请假状态',
    姓名:'姓名',
    照片:'照片',
    证件号码:'证件号码',
    身份证号:'身份证号',
    住址:'住址',
    出生日期:'出生日期',
    电话:'电话',
    入矫时间:'入矫时间',
    矫正计划:'矫正计划',
    人员:'人员'
}
export default columnCheck